import * as userRequest from "@/utils/userRequest";

export default async function getAnnouncementService(
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any
) {
  try {
    const res = await userRequest.get("helper/announce", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (res) {
      onSuccess && onSuccess(res);
      return res;
    }
  } catch (err) {
    console.error("🚀 ~ getAnnouncementService ~ err:", err);
    handleError && handleError(err);
    throw err;
  }
}
